import React, { useState, useEffect } from 'react';
import { generateTestUrl, saveNewCredentials } from '../utils/routingUtils';
import { getStorage, ref, listAll, getDownloadURL, uploadBytes } from 'firebase/storage';
// import { doc, getDoc, setDoc } from 'firebase/firestore';
// import { db } from '../firebase';
import JSZip from 'jszip';
import './VoxTestsAdmin.css';

// Composant pour afficher la liste des enregistrements
const VoxTestsList = ({ onRecordingsUpdate }) => {
  const [recordings, setRecordings] = useState({});
  const [loading, setLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadTotal, setDownloadTotal] = useState(0);
  const [cancelDownload, setCancelDownload] = useState(false);
  const [expandedFolders, setExpandedFolders] = useState({});

  useEffect(() => {
    fetchVoxTestRecordings();
  }, []);


  const fetchVoxTestRecordings = async () => {
    setLoading(true);
    try {
      const storage = getStorage();
      const recordingsRef = ref(storage, 'recordings');
      const userFolders = await listAll(recordingsRef);
      
      
      const voxTestFolders = {};
      
      for (const userFolder of userFolders.prefixes) {
        // Filtrer seulement les dossiers VoxTest (btXXX_voxtest-external)
        if (userFolder.name.includes('_voxtest-external')) {
          const files = await listAll(userFolder);
          const folderFiles = [];
          
          for (const file of files.items) {
            // Chercher uniquement les fichiers VoxTest (etape1.wav, etape2.wav...)
            if (file.name.startsWith('etape') && (file.name.endsWith('.wav') || file.name.endsWith('.webm'))) {
              const url = await getDownloadURL(file);
              
              // Extraire le numéro d'étape pour le tri
              const stepMatch = file.name.match(/etape(\d+)/);
              const stepNumber = stepMatch ? parseInt(stepMatch[1]) : 0;
              
              folderFiles.push({
                id: `${userFolder.name}_${file.name}`,
                fileName: file.name,
                stepNumber: stepNumber,
                url: url,
                timestamp: file.timeCreated || new Date(),
                size: file.size || 0
              });
            }
          }
          
          // Trier les fichiers par numéro d'étape (etape1, etape2, ...)
          folderFiles.sort((a, b) => a.stepNumber - b.stepNumber);
          
          // Extraire le btId depuis le nom du dossier
          const btId = userFolder.name.replace('_voxtest-external', '').toUpperCase();
          
          if (folderFiles.length > 0) {
            voxTestFolders[btId] = {
              btId: btId,
              folderName: userFolder.name,
              files: folderFiles,
              totalFiles: folderFiles.length,
              lastUpdate: Math.max(...folderFiles.map(f => new Date(f.timestamp).getTime()))
            };
          }
        }
      }
      
      setRecordings(voxTestFolders);
      
      // Mettre à jour les stats dans le composant parent
      if (onRecordingsUpdate) {
        onRecordingsUpdate(voxTestFolders);
      }
      
    } catch (error) {
      console.error('Erreur chargement enregistrements VoxTest:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  
  const cancelDownloadProcess = () => {
    setCancelDownload(true);
  };

  // Fonction pour télécharger un ZIP de tous les fichiers
  const downloadZip = async () => {
    // Convertir la structure arborescente en tableau de fichiers
    const filesToZip = [];
    Object.keys(recordings).forEach(btId => {
      const folderData = recordings[btId];
      folderData.files.forEach(file => {
        filesToZip.push({
          ...file,
          btId: btId // Ajouter le btId pour nommage
        });
      });
    });
    
    if (filesToZip.length === 0) {
      alert('Aucun fichier à télécharger');
      return;
    }

    const confirmed = window.confirm(
      `📦 Créer un ZIP avec ${filesToZip.length} fichiers ?`
    );
    
    if (!confirmed) return;

    setIsDownloading(true);
    setDownloadProgress(0);
    setDownloadTotal(filesToZip.length);
    setCancelDownload(false);

    try {
      const zip = new JSZip();
      
      console.log(`📦 Création ZIP: ${filesToZip.length} fichiers...`);
      
      for (let i = 0; i < filesToZip.length && !cancelDownload; i++) {
        const recording = filesToZip[i];
        setDownloadProgress(i + 1);
        
        try {
          console.log(`📦 Ajout ${i+1}/${filesToZip.length}: ${recording.fileName}`);
          
          // Utiliser fetch direct (CORS résolu maintenant !)
          const response = await fetch(recording.url);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          
          const audioBlob = await response.blob();
          // Éviter collision noms : utiliser btId + nom original Firebase
          const fileName = `${recording.btId}_${recording.fileName}`;
          
          zip.file(fileName, audioBlob);
          
        } catch (error) {
          console.error(`❌ Erreur fichier ${recording.fileName}:`, error);
        }
      }
      
      if (!cancelDownload && Object.keys(zip.files).length > 0) {
        console.log('📦 Génération du ZIP...');
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        
        // Télécharger le ZIP
        const now = new Date();
        const timestamp = now.toISOString().slice(0, 19).replace(/:/g, '-');
        const zipName = `VoxTests_${timestamp}.zip`;
        
        const url = URL.createObjectURL(zipBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = zipName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        console.log(`✅ ZIP téléchargé: ${zipName}`);
        alert(`✅ ZIP créé avec succès!\n\n${Object.keys(zip.files).length} fichiers dans ${zipName}`);
      }
      
    } catch (error) {
      console.error('❌ Erreur création ZIP:', error);
      alert(`❌ Erreur lors de la création du ZIP:\n${error.message}`);
    } finally {
      setIsDownloading(false);
      setDownloadProgress(0);
      setDownloadTotal(0);
      setCancelDownload(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-recordings">
        <div className="loading-spinner"></div>
        <p>Chargement des enregistrements...</p>
      </div>
    );
  }

  const recordingFolders = Object.keys(recordings);
  
  if (recordingFolders.length === 0) {
    return (
      <div className="no-recordings">
        <p>🎙️ Aucun enregistrement VoxTest trouvé</p>
        <p>Les enregistrements apparaîtront ici après que des participants aient utilisé les liens générés.</p>
      </div>
    );
  }

  const toggleFolder = (btId) => {
    setExpandedFolders(prev => ({
      ...prev,
      [btId]: !prev[btId]
    }));
  };

  const downloadFolderZip = async (btId) => {
    const folderData = recordings[btId];
    if (!folderData || folderData.files.length === 0) return;

    setIsDownloading(true);
    setDownloadProgress(0);
    setDownloadTotal(folderData.files.length);

    const zip = new JSZip();
    
    try {
      for (let i = 0; i < folderData.files.length; i++) {
        if (cancelDownload) break;
        
        const file = folderData.files[i];
        const response = await fetch(file.url);
        const audioBlob = await response.blob();
        zip.file(file.fileName, audioBlob);
        
        setDownloadProgress(i + 1);
      }

      if (!cancelDownload) {
        const content = await zip.generateAsync({ type: 'blob' });
        const url = window.URL.createObjectURL(content);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${btId}_VoxTest_10etapes.zip`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error('Erreur lors du téléchargement:', error);
    } finally {
      setIsDownloading(false);
      setCancelDownload(false);
    }
  };

  const totalFiles = recordingFolders.reduce((sum, btId) => sum + recordings[btId].totalFiles, 0);

  return (
    <div className="recordings-list">
      <div className="recordings-header">
        <div className="header-left">
          <span className="recording-count">📊 {recordingFolders.length} utilisateurs • {totalFiles} fichiers</span>
        </div>
        <div className="header-actions">
          {isDownloading && (
            <div className="download-progress">
              <button 
                onClick={cancelDownloadProcess}
                className="cancel-download-btn"
                title="Annuler le téléchargement"
              >
                ⏹️ Annuler
              </button>
              <span className="progress-text">
                📥 {downloadProgress}/{downloadTotal} fichiers...
              </span>
            </div>
          )}
          <button 
            onClick={() => downloadZip()} 
            className="zip-all-btn"
            disabled={isDownloading}
            title="Télécharger ZIP de tous les fichiers"
          >
            📦 ZIP Tout
          </button>
          <button onClick={fetchVoxTestRecordings} className="refresh-btn" title="Actualiser">
            🔄
          </button>
        </div>
      </div>
      
      <div className="recordings-tree">
        {recordingFolders.map((btId) => {
          const folderData = recordings[btId];
          const isExpanded = expandedFolders[btId];
          
          return (
            <div key={btId} className="folder-container">
              <div className="folder-header" onClick={() => toggleFolder(btId)}>
                <span className="folder-icon">{isExpanded ? '📂' : '📁'}</span>
                <span className="folder-name">{btId}_VOXTEST-EXTERNAL</span>
                <span className="folder-info">({folderData.totalFiles} fichiers)</span>
                <span className="folder-date">{formatDate(folderData.lastUpdate)}</span>
                <button 
                  className="folder-download-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    downloadFolderZip(btId);
                  }}
                  disabled={isDownloading}
                  title={`Télécharger ZIP ${btId}`}
                >
                  📦
                </button>
              </div>
              
              {isExpanded && (
                <div className="folder-files">
                  {folderData.files.map((file, index) => (
                    <div key={file.id} className="file-item">
                      <div className="file-info">
                        <span className="file-icon">🎵</span>
                        <span className="file-name">{file.fileName}</span>
                        <span className="file-size">{formatFileSize(file.size)}</span>
                        <span className="file-date">{formatDate(file.timestamp)}</span>
                      </div>
                      <div className="file-actions">
                        <audio controls preload="none" className="audio-player-small">
                          <source src={file.url} type="audio/wav" />
                        </audio>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const VoxTestsAdmin = ({ user, onClose }) => {
  const [generatedLink, setGeneratedLink] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [currentBtNumber, setCurrentBtNumber] = useState(0);
  const [isLoadingCounter, setIsLoadingCounter] = useState(true);
  const [recordings, setRecordings] = useState({}); // Pour les stats


  // 🔄 SYNCHRONISATION FIREBASE : Scanner tous les BT existants
  const scanExistingBtNumbers = async () => {
    try {
      console.log('🔍 Scan des BT existants dans Firebase...');
      
      // Réutiliser exactement la même logique que fetchVoxTestRecordings
      const storage = getStorage();
      const recordingsRef = ref(storage, 'recordings');
      const userFolders = await listAll(recordingsRef);
      
      const btNumbers = [];
      
      for (const userFolder of userFolders.prefixes) {
        // Filtrer seulement les dossiers VoxTest (même logique exacte que fetchVoxTestRecordings)
        if (userFolder.name.includes('_voxtest-external')) {
          // Extraire le btId depuis le nom du dossier
          const btId = userFolder.name.replace('_voxtest-external', '').toUpperCase();
          
          const btNumberMatch = btId.match(/^BT(\d+)$/);
          if (btNumberMatch) {
            const number = parseInt(btNumberMatch[1]);
            btNumbers.push(number);
            console.log(`✅ BT trouvé: ${btId} (numéro ${number})`);
          }
        }
      }
      
      // Déterminer le prochain numéro
      const maxBtNumber = btNumbers.length > 0 ? Math.max(...btNumbers) : 0;
      console.log(`📊 Max BT trouvé: ${maxBtNumber}, prochain sera: ${maxBtNumber + 1}`);
      
      return maxBtNumber;
    } catch (error) {
      console.error('❌ Erreur scan BT:', error);
      return 0; // Fallback
    }
  };

  // 🔄 SYNCHRONISATION FIREBASE : Lire le compteur depuis Storage
  const loadBtCounterFromFirebase = async () => {
    try {
      setIsLoadingCounter(true);
      
      // 1. Scanner les BT existants dans Storage
      const scannedMaxBt = await scanExistingBtNumbers();
      
      // 2. Essayer de lire le compteur depuis Storage (fichier JSON)
      let storageCounter = 0;
      try {
        const storage = getStorage();
        const counterRef = ref(storage, 'admin/bt_counter.json');
        const url = await getDownloadURL(counterRef);
        const response = await fetch(url);
        const data = await response.json();
        storageCounter = data.current || 0;
        console.log(`📖 Compteur Storage: ${storageCounter}`);
      } catch (error) {
        console.log('📖 Aucun compteur Storage trouvé:', error.message);
      }
      
      // 3. Logique de synchronisation intelligente
      let finalCounter;
      
      if (scannedMaxBt === 0) {
        // Si aucun dossier BT trouvé dans Storage, reset à 0 (prochain sera BT001)
        finalCounter = 0;
        console.log(`🔄 Aucun dossier BT trouvé → Reset compteur à 0`);
        
        // Mettre à jour le fichier JSON pour refléter le reset
        await updateBtCounterInStorage(0);
      } else {
        // Prendre le maximum entre scan et compteur stocké
        finalCounter = Math.max(scannedMaxBt, storageCounter);
        console.log(`🎯 Compteur synchronisé: max(${scannedMaxBt}, ${storageCounter}) = ${finalCounter}`);
        
        // Mettre à jour Storage si nécessaire
        if (finalCounter > storageCounter) {
          await updateBtCounterInStorage(finalCounter);
        }
      }
      
      setCurrentBtNumber(finalCounter);
      
    } catch (error) {
      console.error('❌ Erreur chargement compteur:', error);
      // Fallback: utiliser localStorage si Firebase échoue
      const localCounter = parseInt(localStorage.getItem('last_bt_number') || '0');
      setCurrentBtNumber(localCounter);
    } finally {
      setIsLoadingCounter(false);
    }
  };

  // 🔄 SYNCHRONISATION FIREBASE : Mettre à jour le compteur dans Storage
  const updateBtCounterInStorage = async (newNumber) => {
    try {
      const storage = getStorage();
      const counterRef = ref(storage, 'admin/bt_counter.json');
      
      // Créer le contenu JSON
      const counterData = {
        current: newNumber,
        lastUpdated: new Date().toISOString(),
        source: 'admin_generation'
      };
      
      // Convertir en Blob
      const blob = new Blob([JSON.stringify(counterData, null, 2)], { type: 'application/json' });
      
      // Upload vers Storage
      await uploadBytes(counterRef, blob);
      console.log(`💾 Compteur Storage mis à jour: ${newNumber}`);
      
      // Backup localStorage pour compatibilité
      localStorage.setItem('last_bt_number', newNumber.toString());
    } catch (error) {
      console.error('❌ Erreur mise à jour compteur:', error);
      // Fallback: sauvegarder dans localStorage seulement
      localStorage.setItem('last_bt_number', newNumber.toString());
    }
  };
  
  // Alias pour compatibilité
  const updateBtCounterInFirebase = updateBtCounterInStorage;

  // Charger le compteur au montage du composant
  useEffect(() => {
    // Toujours essayer Firebase Storage d'abord, même en mode localhost
    loadBtCounterFromFirebase();
  }, []);

  // Générer un nouveau lien BT avec synchronisation Firebase
  const generateNewLink = async () => {
    setIsGenerating(true);
    setCopySuccess(false);
    
    try {
      // Générer un nouveau BT ID séquentiel depuis le compteur Firebase
      const nextNumber = currentBtNumber + 1;
      const btId = `BT${String(nextNumber).padStart(3, '0')}`; // BT001, BT002, etc.
      const password = Math.random().toString(36).substring(2, 10); // 8 caractères aléatoires
      
      console.log(`🆕 Génération BT${String(nextNumber).padStart(3, '0')}`);
      
      // Mettre à jour le compteur dans Firebase ET localement
      await updateBtCounterInFirebase(nextNumber);
      setCurrentBtNumber(nextNumber);
      
      // Construire l'URL complète
      const baseUrl = 'https://thor-c5078.firebaseapp.com';
      const fullUrl = `${baseUrl}/record/${btId}/${password}`;
      
      setGeneratedLink(fullUrl);
      
      // Sauvegarder les credentials
      const saved = saveNewCredentials(btId, password);
      if (saved) {
        console.log('✅ Credentials sauvegardés:', { btId, password, url: fullUrl });
      } else {
        console.error('❌ Erreur sauvegarde credentials');
      }
      
    } catch (error) {
      console.error('❌ Erreur génération lien:', error);
      alert('Erreur lors de la génération du lien. Veuillez réessayer.');
    } finally {
      setIsGenerating(false);
    }
  };

  // Copier le lien dans le presse-papier
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(generatedLink);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Erreur copie:', err);
    }
  };



  return (
    <div className="voxtests-admin">
      <div className="admin-header">
        <h2>🔧 Administration VoxTests</h2>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      <div className="admin-content">
        {/* Section Générer Lien */}
        <div className="admin-section">
          <h3>📎 Générer un nouveau lien</h3>
          <p className="section-description">
            Créer un lien unique pour un nouveau participant au test vocal
          </p>
          <div className="counter-display">
            {isLoadingCounter ? (
              <div className="loading-counter">
                <span>🔄 Synchronisation avec Firebase...</span>
              </div>
            ) : (
              <>
                <strong>Compteur actuel : BT{String(currentBtNumber).padStart(3, '0')}</strong>
                <span className="next-user">→ Prochain utilisateur : BT{String(currentBtNumber + 1).padStart(3, '0')}</span>
                <button 
                  className="refresh-counter-btn"
                  onClick={loadBtCounterFromFirebase}
                  disabled={isLoadingCounter}
                  title="Actualiser le compteur depuis Firebase"
                >
                  🔄
                </button>
              </>
            )}
          </div>
          
          <button 
            className="primary-btn generate-btn"
            onClick={generateNewLink}
            disabled={isGenerating || isLoadingCounter}
          >
            {isGenerating ? 'Génération...' : 'Générer nouveau lien'}
          </button>

          {generatedLink && (
            <div className="link-display">
              <input 
                type="text" 
                value={generatedLink} 
                readOnly 
                className="link-input"
              />
              <button 
                className="copy-btn"
                onClick={copyToClipboard}
                title="Copier le lien"
              >
                {copySuccess ? '✓' : '📋'}
              </button>
            </div>
          )}
        </div>

        {/* Section Liste des enregistrements */}
        <div className="admin-section">
          <h3>🎙️ Enregistrements VoxTest</h3>
          <p className="section-description">
            Liste de tous les tests vocaux avec téléchargement individuel
          </p>
          
          <VoxTestsList onRecordingsUpdate={setRecordings} />
        </div>

        {/* Statistiques rapides */}
        <div className="admin-stats">
          <div className="stat-item">
            <span className="stat-label">👥 Utilisateurs VoxTest</span>
            <span className="stat-value">{Object.keys(recordings).length}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">🔗 Liens générés</span>
            <span className="stat-value">{currentBtNumber}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoxTestsAdmin;